import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { getCloudLang } from '@/utils/fns';

// 引入i18n国际化插件
Vue.use(VueI18n);

//  require.context()第一个参不能是变量
function getContextContent(modules) {
  const config = {};
  modules.keys().forEach(filename => {
    const content = modules(filename).default;
    const module = filename.replace(/^\.\//, '').replace(/\.js$/, '');
    config[module] = content;
  });
  return config;
}

function getLangFiles() {
  const modules = require.context('./en', false, /\.js$/);
  return modules.keys().map(filename => filename.replace(/^\.\//, '').replace(/\.js$/, ''));
}

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: getCloudLang(),
  messages: {
    cn: getContextContent(require.context('./cn', false, /\.js$/)),
    tw: getContextContent(require.context('./tw', false, /\.js$/)),
    en: getContextContent(require.context('./en', false, /\.js$/)),
    fr: getContextContent(require.context('./fr', false, /\.js$/)),
    es: getContextContent(require.context('./es', false, /\.js$/)),
    de: getContextContent(require.context('./de', false, /\.js$/)),
    it: getContextContent(require.context('./it', false, /\.js$/)),
    pt: getContextContent(require.context('./pt', false, /\.js$/)),
    ru: getContextContent(require.context('./ru', false, /\.js$/)),
    pl: getContextContent(require.context('./pl', false, /\.js$/)),
    nl: getContextContent(require.context('./nl', false, /\.js$/)),
    se: getContextContent(require.context('./se', false, /\.js$/)),
    jp: getContextContent(require.context('./jp', false, /\.js$/)),
    kr: getContextContent(require.context('./kr', false, /\.js$/)),
    vn: getContextContent(require.context('./vn', false, /\.js$/)),
    th: getContextContent(require.context('./th', false, /\.js$/)),
    kh: getContextContent(require.context('./kh', false, /\.js$/)),
    tr: getContextContent(require.context('./tr', false, /\.js$/)),
    ar: getContextContent(require.context('./ar', false, /\.js$/)),
    il: getContextContent(require.context('./il', false, /\.js$/)),
    fa: getContextContent(require.context('./fa', false, /\.js$/)),
  },
});

Vue.mixin({
  computed: {
    i18n() {
      const arr = getLangFiles();
      const obj = {};
      arr.forEach(x => {
        obj[x] = i18n.t(x);
      });
      return obj.index;
    },
  },
});

export default i18n;
export function $t(args) {
  return i18n.tc.call(i18n, args);
}
